import { createSelector } from "@reduxjs/toolkit";
import { openapi } from "../../openapi";
import { IRootState } from "../app/store";
import { selectProjectNo } from "../globalSelectors";
import { selectGetMcbimStandardSpaceArgs } from "./httpArgsMcBimSelectors";

export const selectHttpGetMcBimStandardSpace = createSelector(
  [selectGetMcbimStandardSpaceArgs, (state: IRootState) => state],
  (args, state) => {
    if (!args) return null;
    return openapi.endpoints.getMcbimSingleMcbimSpace.select(args)(state).data ?? null;
  }
);

export const selectHttpMcBimItemsInStandardSpace = createSelector(
  [selectHttpGetMcBimStandardSpace, selectProjectNo, (state: IRootState) => state],
  (mcbimSpace, projectNo, state) => {
    if (!mcbimSpace) return [];
    const args = {
      projectNo: projectNo,
      spaceId: mcbimSpace._id as string,
    };
    return openapi.endpoints.getMcbimItemsInSpace.select(args)(state).data ?? [];
  }
);
